import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SharedSurveyResultsComponent } from './shared-survey-results.component';

const routes: Routes = [
  // Module is lazy loaded, see app-routing.module.ts
  { path: ':id', component: SharedSurveyResultsComponent, data: { title: 'Resultados' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class SharedSurveyResultsRoutingModule { }
